import { createRouter, createWebHistory } from 'vue-router';

import HomeView from '@/views/HomeView.vue';
import GameView from '@/views/GameView.vue';
import SpotifyCallbackView from '@/views/SpotifyCallbackView.vue';
import SettingsView from '@/views/SettingsView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'SoundBattle - Home'
    }
  },
  {
    path: '/game',
    name: 'game',
    component: GameView,
    meta: {
      title: 'SoundBattle - Spiel'
    }
  },
  {
    path: '/spotify/callback',
    name: 'spotify-callback',
    component: SpotifyCallbackView,
    meta: {
      title: 'SoundBattle - Spotify Login'
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView,
    meta: {
      title: 'SoundBattle - Einstellungen'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Navigation Guard: Seitentitel setzen
router.beforeEach((to: any, from: any, next: any) => {
  document.title = (to.meta?.title as string) || 'SoundBattle';
  next();
});


export default router;
